import { FooterHomeFragment, FooterQuery } from "../../../graphql-types";

type Link = {
  external?: boolean;
  href: string;
  title: string;
};

/**
 * This function is a bit messy at the moment. It will become simpler once
 * we update the Contentful model to match the new UI.
 */
export function putLinksInThreeColumns(
  { footerLinks, faq, legals, additionalExternalLinks }: FooterHomeFragment,
  sitemap: FooterQuery["sitemap"]
) {
  const links: Link[] = [];
  footerLinks.forEach((item) => {
    links.push({ href: item.path, title: item.title });
  });

  if (faq) {
    links.push({ href: faq.path, title: faq.title });
  }

  if (legals?.whatsInOurProductsLabel && legals?.whatsInOurProductsUrl) {
    links.push({
      href: legals.whatsInOurProductsUrl,
      title: legals.whatsInOurProductsLabel,
      external: true,
    });
  }

  if (
    legals?.protectionOfPersonalDataLabel &&
    legals?.protectionOfPersonalDataUrl
  ) {
    links.push({
      href: legals.protectionOfPersonalDataUrl,
      title: legals.protectionOfPersonalDataLabel,
      external: true,
    });
  }

  if (legals?.legalWarningLabel && legals?.legalWarningUrl) {
    links.push({
      href: legals.legalWarningUrl,
      title: legals.legalWarningLabel,
      external: true,
    });
  }

  legals?.additionalMessages?.forEach((item) => {
    links.push({ href: `${item?.slug}.html`, title: item?.title || "" });
  });

  additionalExternalLinks.forEach((item) => {
    links.push({ href: item.url, title: item.title, external: true });
  });

  if (sitemap) {
    links.push({ href: sitemap.path, title: sitemap.title });
  }

  return links.reduce(
    (acc, item, index) => {
      const [one, two, three] = acc;
      if (index % 3 === 0) {
        return [[...one, item], two, three];
      } else if (index % 3 === 1) {
        return [one, [...two, item], three];
      } else {
        return [one, two, [...three, item]];
      }
    },
    [[], [], []] as Link[][]
  );
}
